import React from 'react';
import { SvgIcon, } from './SvgIcon';
import { ISvgIconProps, } from './interface';

export const ActivityIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </SvgIcon>;
};
